<template>
<div>
  <div class="modal">
    <div class="modal-dialog">
      <div :class="{ 
        'modal-content': true,
        }">
        <div class="modal-body">
          <span>請輸入新密碼</span>
          <input class="form-control" type="password" v-model="password1">
          <br>
          <span>請再一次輸入新密碼</span>
          <input class="form-control" type="password" v-model="password2">
          <span v-if="errMsg !== ''" class="error-message"><small>{{ errMsg }}</small></span>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="changePassword" :disabled="password1 !== password2">確定更改</button>
          <button class="btn btn-info" @click="closePanel">取消</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'PasswordChange',
  props: ['userId'],
  data() {
    return {
      password1: null,
      password2: null,
      errMsg: '',
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    changePassword() {
      if (this.password1 === this.password2) {
        this.instance.patch(`/api/user/${this.userId}/`, {
          password: this.password2,
        })
        .then((res) => {
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '更新成功',
          });
          this.$emit('closePanel');
        })
        .catch(() => {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '更新失敗',
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認新密碼一致',
        });
      }
    },
    closePanel() {
      this.$emit('closePanel');
    },
  },
  watch: {
    password2() {
      if (this.password2 !== this.password1) {
        this.errMsg = '請確認密碼一致';
      } else {
        this.errMsg = '';
      }
    },
  },
};
</script>

<style lang="sass">
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);

.modal-dialog
  // margin-top: 300px !important
  width: 500px !important

.modal-error
  border-color: #FF3811
  background-color: #FF3811
  color: white

.modal-warning
  border-color: #ff960c
  background-color:#ff960c
  color: white

.modal-success
  border-color: #42b883
  background-color: #42b883
  color: white  

.modal-footer
  justify-content: center
  border: 0
  .btn
    border: 1px solid white

.modal-body
  p
    margin-bottom: 0

.error-message
  margin: 0
  color: red

</style>




// WEBPACK FOOTER //
// PasswordChange.vue?548b3d24